export { default } from "./Simple";
